<template>
    <div class="section">
        <div class="row mt-1">
            <div class="col-12">
                <div class="stat-box">
                    <div class="title mal-text">അപേക്ഷകൾ</div>
                    <div class="value text-primary">{{ responseData.count_total ? responseData.count_total : '00' }}</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Filters -->
    <div class="section mt-2">
        <div class="ss-filter-card">
            <label class="ss-label mal-text" for="program_filter">പദ്ധതി</label>
            <select
                class="form-select form-select-sm mal-text"
                v-model="program_id"
                id="program_filter"
                style="border-radius:10px;"
                @change="loadReport()"
            >
                <option value="">എല്ലാ പദ്ധതികളും</option>
                <option v-for="p in programs" :key="p.id" :value="p.id">{{ p.title }}</option>
            </select>

            <!-- VO noted-only toggle -->
            <div class="ss-toggle-row" @click="vo_noted_only = !vo_noted_only; loadReport()">
                <span class="ss-toggle-text mal-text">Verification Officer നോട്ട് ചെയ്തവ മാത്രം</span>
                <div class="form-check form-switch mb-0" @click.stop>
                    <input class="form-check-input" type="checkbox" id="vo_noted_only"
                        v-model="vo_noted_only" @change="loadReport()">
                </div>
            </div>

            <!-- Manage Verification Officers (district / permitted zone) -->
            <router-link v-if="voContext.can_suggest" :to="voManagePath" class="ss-vo-btn">
                <ion-icon name="people-outline"></ion-icon>
                <span>Verification Officers</span>
                <ion-icon name="chevron-forward-outline" class="ss-vo-arrow"></ion-icon>
            </router-link>

            <!-- Approve Verification Officers (designated approvers) -->
            <router-link v-if="voContext.can_approve_vo" :to="voApprovePath" class="ss-vo-btn" style="background:#eafaf1;border-color:#bfe9d0;color:#12a85a;">
                <ion-icon name="shield-checkmark-outline"></ion-icon>
                <span>VO Approvals</span>
                <span v-if="voContext.pending_vo_count" class="badge bg-danger ms-1">{{ voContext.pending_vo_count }}</span>
                <ion-icon name="chevron-forward-outline" class="ss-vo-arrow"></ion-icon>
            </router-link>
        </div>
    </div>

    <div class="section pt-0 mt-2">
        <div class="listed-detail mt-0">
            <h3 class="text-center mt-0 mal-text custom-title">{{ page_title }}</h3>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-0" v-if="!loading_list && isEmptyList">
        <h4 class="text-center mt-0 mal-text">ഇതുവരെ അപേക്ഷകൾ ഇല്ല</h4>
    </div>

    <div class="section mt-2" v-if="!loading_list && !isEmptyList && user_level < 4">
        <div class="card">
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">പേര്</th>
                            <th scope="col">അപേക്ഷകൾ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in member_lists" :key="row.id === null ? 'no-zone' : row.id">
                            <td class="text-primary font-dark mal-text">
                                <router-link
                                    v-if="row.id !== null"
                                    :to="'/org/' + (user_level + 1) + '/' + row.id + '/sneha-sparsham-report' + programQuery"
                                >
                                    {{ row.name }}
                                </router-link>
                                <span v-else>{{ row.name }}</span>
                            </td>
                            <td class="text-primary font-dark">{{ row.family_count || 0 }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="section mt-2" v-if="!loading_list && user_level === 4 && member_lists.length">
        <router-link
            v-for="row in member_lists"
            :key="row.id"
            :to="applicationDetailPath(row.id)"
            class="d-block text-decoration-none"
        >
            <div class="card mb-2 sneha-app-card">
                <div class="card-body mal-text">
                    <div class="d-flex justify-content-between align-items-start">
                        <h5 class="mb-1 text-primary">{{ row.name }}</h5>
                        <ion-icon name="chevron-forward-outline" class="text-muted"></ion-icon>
                    </div>
                    <p class="mb-0 text-muted small">{{ row.program_title }}</p>
                    <p class="mb-0 small" v-if="row.contact">ഫോൺ: {{ row.contact }}</p>
                    <p class="mb-0 small" v-if="row.created_at">തീയതി: {{ row.created_at }}</p>
                    <span v-if="row.verification_status && row.verification_status !== 'pending'"
                        class="badge mt-1" :class="verificationBadgeClass(row.verification_status)">
                        {{ verificationLabel(row.verification_status) }}
                    </span>
                </div>
            </div>
        </router-link>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import UserService from "@/services/user.service";
import AlertModel from "../layouts/AlertModel.vue";

export default {
    name: "SnehaSparshamReport",
    components: { AlertModel },
    data() {
        return {
            loading_list: false,
            user_level: 1,
            member_lists: [],
            responseData: {},
            page_title: "",
            programs: [],
            program_id: "",
            alert_type: "",
            alert_message: "",
            vo_noted_only: false,
            voContext: { can_suggest: false, suggestion_questions: [] },
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isEmptyList() {
            if (Array.isArray(this.member_lists)) {
                return this.member_lists.length <= 0;
            }
            return !this.member_lists || (this.member_lists.length !== undefined && this.member_lists.length <= 0);
        },
        programQuery() {
            return this.program_id ? "?program_id=" + this.program_id : "";
        },
        voManagePath() {
            return "/org/" + this.$route.params.sub_level + "/" + this.$route.params.id + "/sneha-sparsham-vo";
        },
        voApprovePath() {
            return "/org/" + this.$route.params.sub_level + "/" + this.$route.params.id + "/sneha-sparsham-vo-approve";
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level, 10);
        if (this.$route.query.program_id) {
            this.program_id = this.$route.query.program_id;
        }
        this.$root.updateParent("സ്നേഹ സ്പർശം റിപ്പോർട്ട്");
        this.loadReport();
        this.loadVoContext();
    },
    methods: {
        verificationLabel(s) {
            return s === 'verified' ? 'Verified'
                : s === 'not_verified' ? 'Not Verified'
                : s === 'edit_requested' ? 'Edit Requested'
                : s === 'resubmitted' ? 'Resubmitted' : s;
        },
        verificationBadgeClass(s) {
            return s === 'verified' ? 'bg-success'
                : s === 'resubmitted' ? 'bg-info'
                : 'bg-danger';
        },
        loadVoContext() {
            UserService.authPostRequest("get-sneha-sparsham-vo-context", {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10),
            }).then(
                (response) => {
                    if (response.data.status === "success") {
                        this.voContext = response.data.data;
                    }
                },
                () => {}
            );
        },
        applicationDetailPath(applicationId) {
            return (
                "/org/" +
                this.$route.params.sub_level +
                "/" +
                this.$route.params.id +
                "/sneha-sparsham-application/" +
                applicationId
            );
        },
        loadReport() {
            this.loading_list = true;
            const data = {
                user_level: this.user_level,
                user_level_id: parseInt(this.$route.params.id, 10),
                program_id: this.program_id || null,
                vo_noted_only: this.vo_noted_only ? 1 : 0,
            };
            UserService.authPostRequest("get-sneha-sparsham-report", data).then(
                (response) => {
                    this.loading_list = false;
                    if (response.data.status === "success") {
                        this.responseData = response.data.data;
                        this.member_lists = response.data.data.list || [];
                        this.page_title = response.data.data.page_title || "";
                        this.programs = response.data.data.programs || [];
                    } else {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                () => {
                    this.loading_list = false;
                }
            );
        },
    },
};
</script>

<style scoped>
.field-label { font-size: 11px; font-weight: 600; color: #64748b; margin-bottom: 3px; display: block; }

/* Filters card */
.ss-filter-card {
    background: #fff;
    border: 1px solid #eef0f5;
    border-radius: 12px;
    padding: 12px 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.ss-label {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    margin-bottom: 4px;
    display: block;
}
.ss-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    background: #f8fafc;
    border: 1px solid #eef0f5;
    border-radius: 10px;
    padding: 9px 12px;
    margin-top: 10px;
    cursor: pointer;
}
.ss-toggle-text {
    font-size: 12.5px;
    font-weight: 600;
    color: #27173E;
    line-height: 1.3;
    flex: 1;
    min-width: 0;
}
.ss-toggle-row .form-check-input {
    margin-left: 0;
    flex-shrink: 0;
}
.ss-vo-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #eef2ff;
    border: 1px solid #dbe3ff;
    border-radius: 10px;
    padding: 10px 12px;
    margin-top: 10px;
    text-decoration: none;
    color: #1a418c;
    font-size: 13px;
    font-weight: 700;
}
.ss-vo-btn ion-icon { font-size: 17px; flex-shrink: 0; }
.ss-vo-btn span { flex: 1; min-width: 0; }
.ss-vo-arrow { color: #94a3b8; }

.sneha-app-card {
    transition: background-color 0.15s ease;
}
.sneha-app-card:active {
    background-color: #f8f9fa;
}
</style>
